import { render, staticRenderFns } from "./Envelope.vue?vue&type=template&id=119b9e53&scoped=true"
import script from "./Envelope.vue?vue&type=script&lang=js"
export * from "./Envelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b9e53",
  null
  
)

export default component.exports